import React from 'react'
import style from './style.module.css'

export default function Footer(){
    return (
        <div className={style.footer}>

        </div>
    )
}